import styles from './DevelopmentBadge.module.scss';

export interface DevelopmentBadgeProps {
  show?: boolean;
}

function DevelopmentBadge({ show = false }: DevelopmentBadgeProps) {
  if (!show) return null;

  return <div className={styles.componentStyle}>DEV</div>;
}

export default DevelopmentBadge;
